import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
// import { DatePicker, Space } from 'antd';
import { useEffect, useState } from 'react';
// import styled from 'styled-components';

// @mui
import { styled } from '@mui/material/styles';
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';
import { useLocation } from 'react-router-dom';

// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/iconify';
//
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';
import NotificationsPopover from './NotificationsPopover';
import { useFilter } from '../FilterProvider';
// import { DatePicker, LocalizationProvider } from '@mui/lab';
// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;
dayjs.extend(customParseFormat);

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

const CustomToggleButton = styled(ToggleButton)`
  && {
    height: 34px; // Set the desired height
    // background-color: #ff5733; // Set the desired background color
    color: #d24a61; // Set the text color
  }
`;

const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
  && {
    .MuiToggleButton-root {
      // margin: 5px; // Add some spacing around each button
    }
  }
`;
export default function Header({ onOpenNav }) {
  const [alignment, setAlignment] = useState('');
  const { setFilter, filter } = useFilter();
  const [userToggle, setUserToggle] = useState(true);
  const [filterDate, setFilterDate] = useState(filter.date);
  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };
  // const { RangePicker } = DatePicker;
  const dateFormat = 'YYYY/MM/DD';
  const weekFormat = 'MM/DD';
  const monthFormat = 'YYYY/MM';

  const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY'];
  const customFormat = (value) => `custom format: ${value.format(dateFormat)}`;
  const customWeekStartEndFormat = (value) =>
    `${dayjs(value).startOf('week').format(weekFormat)} ~ ${dayjs(value).endOf('week').format(weekFormat)}`;

  const handleDateRangeChange = (dates, dateStrings) => {
    console.log('Selected Date Range:', dates);
    console.log('Selected Date Range (formatted):', dateStrings);
    const dateToModify = new Date(dateStrings[1]);

    // Add 1 day to the date
    dateToModify.setDate(dateToModify.getDate() + 1);

    // Format the modified date back to the original format ('YYYY/MM/DD')
    const modifiedDate = `${dateToModify.getFullYear()}/${(dateToModify.getMonth() + 1)
      .toString()
      .padStart(2, '0')}/${dateToModify.getDate().toString().padStart(2, '0')}`;

    // Update the date in the array
    dateStrings[1] = modifiedDate;

    const convertedDates = dateStrings.map((date) => date.replace(/\//g, '-'));
    console.log(dateStrings);
    const range = {
      fromDate: convertedDates[0],
      toDate: convertedDates[1],
    };
    setFilterDate(range);
  };

  const handleFilter = async () => {
    const newFilter = {
      ...filter, // Preserve existing filter properties
      type: alignment,
      date: filterDate,
    };
    setFilter(newFilter);
  };
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/dashboard/app') {
      setUserToggle(true);
    } else {
      setUserToggle(false);
    }
    console.log(location.pathname === '/dashboard/zodiac');
  }, [location]);

  return '';
}
